export type EnvironmentSharedData = {
  fbLocalAppId: string;
  fbAppId:      string;
  rdApiKey:     string;
};

// noinspection SpellCheckingInspection
export const sharedEnvironment: EnvironmentSharedData = {
  fbLocalAppId: '1947548505342128',
  fbAppId:      '970783532984902',
  rdApiKey:     '5e213249c3bc7186493bfbc69ef7cf0c',
};
